
import eConfig from '../configures';
const TOKEN_KEY = "token";
const TOKEN_USER = "@churchapp-user";

let PostTo = async (host,hub, endpoint, callback) => {
    const server = eConfig[host];
    let url = server + "" + endpoint;
    console.log("$$$$$----> ", url);
    const token = GetLoginToken();
    fetch(url, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(hub)
    })
        .then((response) => response.json())
        .then((response) => {
            //todo let check if the response code is 401 Unauthorized
            if(typeof response.error !=="undefined"){
                if( response.error ==="Unauthorised access to this resource"){
                    //alert("Unauthorised access to this resource, Please login!")
                    window.location.href = "#/login"
                }
            }
            callback(response, null);
        }).catch((e) => {
        callback(null, e, null);
    });
}
let SaveToken = (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_USER, JSON.stringify(user))
}
const GetUserToken = () => {
    return JSON.parse(localStorage.getItem(TOKEN_USER))
}
const GetLoginToken = () => {
    return localStorage.getItem(TOKEN_KEY)
}



export {
    SaveToken,
    GetUserToken,
    PostTo,
};

